import cn from 'classnames';
import { ReactNode } from 'react';
import './styles.scss';

interface FormRowProps {
	children: ReactNode;
	flex?: boolean;
	isSubRow?: boolean;
	noBottomMargin?: boolean;
}
export const FormRow = ({ children, flex = true, isSubRow = false, noBottomMargin = false }: FormRowProps) => {
	return (
		<div
			className={cn('formRow', {
				'formRow--flex': flex,
				'formRow--noBottomMargin': noBottomMargin,
				'formRow--subRow': isSubRow,
			})}
		>
			{children}
		</div>
	);
};

export default FormRow;
